import React, { useEffect, useState } from "react";
import AuthNavComponent from "../../module/auth/AuthNav";
import { Checkbox, Input, toAbsoluteUrl } from "sr/helpers";
import { Link, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { FormattedMessage } from "react-intl";
import { InputNumberFormat } from "sr/helpers/functions/InputNumberFormat";
import { sendOTP } from "sr/utils/api/sendOTP";
import { createIndividual } from "sr/utils/api/individual/createIndividual";
import { login } from "sr/utils/api/login";
import { useAuth } from "app/pages/module/auth";
import individualRegisterSchema from "sr/utils/schemas/individual/individualRegister";
import { ButtonAuth } from "sr/helpers/ui-components/ButtonAuth";
import { useFormik } from "formik";
import { CreateWallet } from "sr/utils/api/wallet/CreateWallet";
import { City } from "app/pages/component/types/city/City";
import { fetchRegion } from "sr/helpers/apiFunctions/region/fetchRegion";
import DropDown from "sr/helpers/ui-components/DropDown.tsx";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import { setRegionIdMe } from "sr/helpers/functions/setCityMe";
import SmartSearchSelect from "sr/helpers/ui-components/SmartSearchSelect";
import { RadioInput } from "sr/helpers/ui-components/RadioInput";
import { ReactSelect } from "sr/helpers/ui-components/ReactSelect";
// import cleanerRegister from "sr/utils/schemas/cleaner/cleanerRegister";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { renderRequiredLabel } from "sr/utils/helper";
import CheckBoxHandle from "sr/helpers/functions/CheckBoxHandle";
import { toast } from "react-toastify";
import { getNearbyRegions } from "sr/utils/api/region/getNearbyRegions";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { getIndividual } from "sr/utils/api/individual/getIndividual";
import { updateIndividual } from "sr/utils/api/individual/updateIndividual";

export const RegisterAsIndividual = ({ targetProfile = false }: { targetProfile?: boolean }) => {
  const [loader, setLoader] = useState(false);
  const { persistToken, setOnboardingStatus } = useAuth();
  const intl = useIntl();
  const [AllCity, setAllCity] = useState<City[]>();
  useEffect(() => {
    fetchRegion({ setData: setAllCity, setLoader: setLoader });
  }, []);
  const [showPassword, setShowPassword] = useState(false);
  const [addNearRegion, setAddNearRegion] = useState(false);
  const [nearbyRegionsList, setNearbyRegionsList] = useState({
    isLoading: false,
    list: [],
  });
  const [allRegionsLoaded, setAllRegionsLoaded] = useState(false);
  const [regions, setRegions] = useState([]);
  const [targetProfileId, setTargetProfileId] = useState<string>();
  interface FormValues {
    username: string;
    mobile_number: string;
    password: string;
    first_name: string;
    last_name: string;
    email: string;
    regionId: string;
    sms_opt_out: boolean | null;
    regions: any[];
  }
  const navigate = useNavigate();

  const initialValues: FormValues = {
    username: "",
    mobile_number: "",
    password: "",
    first_name: "",
    last_name: "",
    email: "",
    regionId: "",
    sms_opt_out: true,
    regions: [],
  };
  const { errors, handleChange, handleSubmit, setFieldValue, values } =
    useFormik({
      initialValues: initialValues,
      enableReinitialize: true,
      validateOnChange: false,
      onSubmit: async (values) => {
        console.log("Values: ", values);
        // return;
        if (addNearRegion && regions.length === 0) {
          toast.error("Please select at least one nearby region.");
          return;
        }
        setLoader(true);

        try {
          if (targetProfile) {
            setRegionIdMe(values.regionId);
            const result = await updateIndividual({
              ...values,
              username: undefined,
              password: undefined,
              id: targetProfileId || getUserDetails()?.user_id,
              onBoardingStatus: true,
            });
            if (result?.success) {
              setOnboardingStatus(true);
              navigate("/individual/jobs", { replace: true });
            }
            setLoader(false);
            return;
          }
          const result = await createIndividual({
            ...values,
            onBoardingStatus: true,
          });

          if (result) {
            const otpresult = await sendOTP({
              username: result?.data?.username,
            });
            const loginresult = await login({
              username: values.username,
              password: values.password,
            });
            if (loginresult.success === true) {
              const data = {
                userType: loginresult?.data?.user.type,
                user_id: loginresult?.data?.auth.user_id,
              };
              localStorage.setItem("auth", JSON.stringify(data));
              persistToken(
                loginresult?.data?.auth.jwt,
                loginresult?.data?.auth?.onBoardingStatus ??
                  loginresult?.data?.onBoardingStatus
              );
              setRegionIdMe(loginresult?.data?.user?.regionId);
              const walletres = await CreateWallet({
                owner_id: loginresult?.data?.auth.user_id,
                owner_type: "INDIVIDUAL",
              });
              setLoader(false);
              navigate("/verify-otp");
            }
          } else {
            setLoader(false);
          }
        } catch (error) {
          setLoader(false);
        }
      },
      validationSchema: targetProfile
        ? individualRegisterSchema.omit(["username", "password"])
        : individualRegisterSchema,
    });
  useEffect(() => {
    let isMounted = true;
    const loadTargetProfile = async () => {
      if (!targetProfile) return;
      const id = getUserDetails()?.user_id;
      if (!id) return;
      setTargetProfileId(id);
      setLoader(true);
      try {
        const response = await getIndividual(new URLSearchParams({ id }));
        const data = response?.data;
        if (!data || !isMounted) return;
        const regionId =
          typeof data.regionId === "object"
            ? data.regionId?.id || data.regionId?._id
            : data.regionId;
        if (regionId) setRegionIdMe(regionId);
        setTargetProfileId(data.id || data._id || id);
        setFieldValue("first_name", data.first_name || "");
        setFieldValue("last_name", data.last_name || "");
        setFieldValue("mobile_number", data.mobile_number || "");
        setFieldValue("email", data.email || "");
        setFieldValue("regionId", regionId || "");
        setFieldValue("sms_opt_out", data.sms_opt_out ?? true);
        setRegions(data.regions || []);
      } finally {
        if (isMounted) setLoader(false);
      }
    };
    loadTargetProfile();
    return () => {
      isMounted = false;
    };
  }, [targetProfile]);

  useEffect(() => {
    setFieldValue("regions", regions);
  }, [regions]);

  const loadgetNearbyRegions = async (limit = 10) => {
    console.log("regionId", values?.regionId);
    setNearbyRegionsList({ ...nearbyRegionsList, isLoading: true });
    setTimeout(async () => {
      const getNearbyRegionsResult = await getNearbyRegions({
        ids: [values?.regionId],
        limit: limit,
      });
      console.log("getNearbyRegionsResult", getNearbyRegionsResult);
      const list = getNearbyRegionsResult?.data || [];

      setNearbyRegionsList({
        isLoading: false,
        list: list,
      });

      // Once we've asked for the "View All" ceiling, there's nothing more
      // to fetch — hide/disable regardless of count returned.
      setAllRegionsLoaded(limit >= 50 || list.length < limit);
    }, 100);
  };

  useEffect(() => {
    if (values?.regionId != undefined) {
      setNearbyRegionsList({
        ...nearbyRegionsList,
        isLoading: false,
        list: [],
      });
      setRegions([]);
      setAddNearRegion(false);
      setAllRegionsLoaded(false);
    }
  }, [values?.regionId]);

  return (
    <>
      {loader && <LoaderFullScreen />}
      <main>
        <div className="lg:container mx-auto lg:max-w-3xl lg:mt-24 mt-8 px-4 lg:px-0">
          <div className="lg:flex-1 lg:flex flex-col h-fit lg:mx-12 mx-auto lg:p-6 p-4 bg-white border border-gray-border rounded-xl">
            <div className="flex justify-center">
              <Link to="/create-cleaner" className="z-50">
                <img
                  width={150}
                  src={toAbsoluteUrl("/media/logos/logo2.png")}
                  alt=""
                  className="bg-white rounded-lg"
                />
              </Link>
            </div>
            <h1 className=" text-xl mt-10">
              {targetProfile ? "Complete your profile" : <FormattedMessage id="ECOMMERCE.COMMON.CREATE_AN_ACCOUNT.TEXT" defaultMessage="Create an Account" />}
            </h1>
            <h3 className=" text-md">
              <FormattedMessage
                id="INDIVIDUAL.REGISTER.ACCOUNT.REGISTERAS.TEXT"
                defaultMessage="As Residential"
              />
            </h3>
            <div className="w-full">
              <form onSubmit={handleSubmit}>
                <Input
                  label={renderRequiredLabel(
                    intl.formatMessage({
                      id: "AUTH.INPUT.FIRSTNAME",
                      defaultMessage: "First Name",
                    }),
                  )}
                  placeholder={intl.formatMessage({
                    id: "AUTH.INPUT.FIRSTNAME.PLACEHOLDER",
                    defaultMessage: "Enter your first name",
                  })}
                  type={"text"}
                  onChange={handleChange}
                  name="first_name"
                  error={errors.first_name}
                  value={values.first_name}
                ></Input>
                <Input
                  label={renderRequiredLabel(
                    intl.formatMessage({
                      id: "AUTH.INPUT.LASTNAME",
                      defaultMessage: "Last Name",
                    }),
                  )}
                  onChange={handleChange}
                  error={errors.last_name}
                  name="last_name"
                  placeholder={"Enter your last name"}
                  type={"text"}
                  value={values.last_name}
                ></Input>
                {!targetProfile && <Input
                  onChange={handleChange}
                  name="username"
                  label={renderRequiredLabel(
                    intl.formatMessage({
                      id: "AUTH.INPUT.USERNAME",
                      defaultMessage: "Username",
                    }),
                  )}
                  placeholder={intl.formatMessage({
                    id: "AUTH.INPUT.USERNAME.PLACEHOLDER",
                    defaultMessage: "Enter your username",
                  })}
                  type={"text"}
                  error={errors.username}
                  value={values.username}
                ></Input>}
                {!targetProfile && <div className="relative">
                  <Input
                    label={renderRequiredLabel(
                      intl.formatMessage({
                        id: "AUTH.INPUT.PASSWORD",
                        defaultMessage: "Password",
                      }),
                    )}
                    placeholder={intl.formatMessage({
                      id: "AUTH.INPUT.PASSWORD.PLACEHOLDER",
                      defaultMessage: "Enter your password",
                    })}
                    type={showPassword ? "text" : "password"}
                    name="password"
                    onChange={handleChange}
                    value={values.password}
                    error={errors.password}
                  />

                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-9 cursor-pointer text-gray-600"
                  >
                    <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                  </span>
                </div>}
                <Input
                  onChange={handleChange}
                  label={renderRequiredLabel(
                    intl.formatMessage({
                      id: "AUTH.INPUT.MOBILENO",
                      defaultMessage: "Mobile Number",
                    }),
                  )}
                  placeholder={intl.formatMessage({
                    id: "AUTH.INPUT.LASTMOBILENONAME.PLACEHOLDER",
                    defaultMessage: "Enter your Mobile Number",
                  })}
                  type={"tel"}
                  name="mobile_number"
                  error={errors.mobile_number}
                  value={InputNumberFormat(values.mobile_number)}
                ></Input>
                <Input
                  label={renderRequiredLabel(
                    intl.formatMessage({
                      id: "AUTH.INPUT.EMAIL.ADDRESS",
                      defaultMessage: "Email Address",
                    }),
                  )}
                  placeholder={intl.formatMessage({
                    id: "AUTH.INPUT.EMAIL.PLACEHOLDER",
                    defaultMessage: "Enter your email id",
                  })}
                  type={"email"}
                  name="email"
                  // error={errors.email}
                  value={values.email}
                  onChange={handleChange}
                  readOnly={targetProfile}
                ></Input>
                {errors.email && (
                  <div className="text-red-500 text-sm mt-1">
                    <FormattedMessage
                      id={errors.email}
                      defaultMessage="Please enter a valid email"
                    />
                  </div>
                )}
                <SmartSearchSelect
                  value={values?.regionId}
                  onChange={(value) => setFieldValue("regionId", value)}
                  options={targetProfile && values?.regionId ? [values?.regionId] : []}
                  label="Region"
                  required={true}
                  error={errors?.regionId}
                  placeholder="Search for a Region..."
                />
                <div className="flex flex-col gap-2">
                  <div className="">
                    <p className="mt-10 mb-1 text-gray-700 text-sm ">
                      <FormattedMessage
                        id="AUTH.INPUT.NEARBYREGION.TITLE"
                        defaultMessage="Do you want to add a nearby region?"
                      />
                    </p>
                    <div className="flex space-x-6">
                      <RadioInput
                        name="Yes"
                        value={true}
                        label={
                          <FormattedMessage
                            id="AUTH.INPUT.NEARBYREGION.NOW"
                            defaultMessage="Now"
                          />
                        }
                        checked={addNearRegion}
                        onChange={async () => {
                          if (values?.regionId) {
                            setAddNearRegion(true);
                            await loadgetNearbyRegions();
                          } else {
                            setAddNearRegion(false);
                            toast.error("Please select a region first");
                          }
                        }}
                      />
                      <RadioInput
                        name="No"
                        value={false}
                        label={
                          <FormattedMessage
                            id="AUTH.INPUT.NEARBYREGION.LATER"
                            defaultMessage="Do it later"
                          />
                        }
                        checked={addNearRegion === false}
                        onChange={() => {
                          setAddNearRegion(false);
                          setRegions([]);
                        }}
                      />
                    </div>
                  </div>
                  {addNearRegion === true && (
                    <div className="border border-gray-300 rounded-md p-4 bg-gray-50">
                      <div className="max-h-40 grid grid-cols-2 gap-2 overflow-y-auto">
                        {nearbyRegionsList.isLoading == true ? (
                          <div className="flex items-center justify-center rounded-md px-2 py-1 col-span-3">
                            <span className="text-sm text-gray-700">
                              Loading...
                            </span>
                          </div>
                        ) : (
                          nearbyRegionsList.list?.map((item, index) => (
                            <div
                              key={index}
                              className="flex items-center justify-between rounded-md border border-gray-border px-2 py-1"
                            >
                              <Checkbox
                                labelClass="font-normal"
                                key={index}
                                checked={regions.includes(item.id)}
                                label={`${item?.city} (${item?.state}), ${item?.distanceMiles} mi`}
                                id={item.id}
                                // name={data.value}
                                value={item.id}
                                onChange={(e) => {
                                  CheckBoxHandle(e, regions, setRegions);
                                }}
                              />
                            </div>
                          ))
                        )}
                      </div>
                      <div className="mt-2 flex justify-center">
                        <button
                          type="button"
                          disabled={allRegionsLoaded}
                          onClick={async () => {
                            if (allRegionsLoaded) {
                              toast.info(
                                "You've already loaded all nearby regions",
                              );
                              return;
                            }
                            if (values?.regionId) {
                              await loadgetNearbyRegions(50);
                            }
                          }}
                          className={`ring-1 rounded px-2 py-1 focus:outline-none focus:shadow-outline ${
                            allRegionsLoaded
                              ? "text-gray-400 ring-gray-300 cursor-not-allowed"
                              : "text-blue-500 hover:text-blue-700"
                          }`}
                        >
                          <FormattedMessage
                            id="AUTH.INPUT.NEARBYREGION.VIEWALL"
                            defaultMessage="View All"
                          />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                <div className="mt-6 border border-gray-300 rounded-md p-4 bg-gray-50">
                  <p className="font-semibold text-sm mb-3">
                    {renderRequiredLabel("SMS Opt-In Agreement")}
                  </p>

                  <div className="space-y-2">
                    <RadioInput
                      name="sms_opt_out"
                      value={false}
                      label="Yes, I would like to receive SMS"
                      checked={values.sms_opt_out === false}
                      onChange={() => setFieldValue("sms_opt_out", false)}
                    />

                    <RadioInput
                      name="sms_opt_out"
                      value={true}
                      label="No, I would not like to receive SMS"
                      checked={values.sms_opt_out === true}
                      onChange={() => setFieldValue("sms_opt_out", true)}
                    />
                  </div>

                  <p className="text-xs text-gray-500 mt-3 leading-relaxed">
                    By opting in, you will receive 1 or more text messages per
                    month related to job applicants, work order updates,
                    supervisor updates, promotions, and more. You can update
                    this later in your account settings. Message and data rates
                    may apply. Reply STOP to unsubscribe or HELP for help.{" "}
                    <a
                      href="https://janijobs.com/privacy-policy/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline"
                    >
                      Privacy Policy
                    </a>{" "}
                    and{" "}
                    <a
                      href="https://support.janijobs.com/hc/en-us/articles/42346401405723-JaniJobs-Global-Terms-and-Conditions"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 underline"
                    >
                      Terms and Conditions
                    </a>{" "}
                    apply.
                  </p>

                  {errors?.sms_opt_out && (
                    <p className="mt-1 text-red-400 md:text-sm sm:text-[.65rem]">
                      Please select Text Message opt out option
                    </p>
                  )}
                </div>
                <div className="flex justify-center">
                  <ButtonAuth
                    loader={loader}
                    onClick={() => {
                      if (!targetProfile) localStorage.setItem("RegisterAs", "Individual");
                    }}
                  >
                    {targetProfile ? "Continue" : <FormattedMessage id="AUTH.GENERAL.CREATE.ACCOUNT.BUTTON" defaultMessage="Create Account" />}
                  </ButtonAuth>
                </div>
              </form>
              {!targetProfile && <div className="mt-10 space-x-1 flex justify-center">
                <span>
                  <FormattedMessage
                    id="AUTH.ALREADY.HAVE.ACCOUNT"
                    defaultMessage="Already have an account?"
                  />
                </span>
                <Link
                  to="/auth"
                  className="cursor-pointer hover:text-pink underline"
                  replace
                >
                  <FormattedMessage
                    id="AUTH.SIGN_IN_HERE"
                    defaultMessage="Sign in here"
                  />
                </Link>
              </div>}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};
